import React, { Component } from 'react'
import { Modal } from 'antd';
import { connect } from "react-redux";
import ShareCollectionForm from './ShareCollectionForm';
import { addNewCollection } from './../actions/collectionActions';
import { Form, Input, Button, Select, Row, Col } from 'antd';


class ShareCollectionModal extends Component {

    handleSubmit = collection => {
        const { addNewCollection, onClose } = this.props;
        
        this.loading(true);
        addNewCollection(collection).then(res => {
            this.loading(false);
            onClose();
        }).catch(error => {
            this.loading(false);
        })
    }

    loading = (value) => this.setState({loading : value});

    render() {
        const { parentCollection, visible, onClose } = this.props;
        return (
                    <Modal title="Share Collection" destroyOnClose={true} visible={visible} onCancel={onClose} footer={null} className="add-modal-container">
                        <ShareCollectionForm parentCollection={parentCollection} onSubmit={this.handleSubmit} onClose = {onClose} />
                    </Modal>
        )
    }
}

const mapStateToProps = (state) => ({
    loggedIn : state.auth.loggedIn,
    user : state.auth.user
  });
  
export default connect(mapStateToProps, {
    addNewCollection
})(ShareCollectionModal);
